import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editButton", "checkbox", "checkAll"]

  connect() {
    this.updateButtonState()
  }

  toggleCheckbox() {
    this.updateButtonState()
    this.updateCheckAllState()
  }

  toggleAll() {
    const checkAll = this.checkAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checkAll
    })
    this.updateButtonState()
  }

  updateCheckAllState() {
    if (this.hasCheckAllTarget) {
      const allChecked = this.checkboxTargets.length > 0 && 
                        this.checkboxTargets.every(cb => cb.checked)
      const someChecked = this.checkboxTargets.some(cb => cb.checked)
      
      this.checkAllTarget.checked = allChecked
      this.checkAllTarget.indeterminate = someChecked && !allChecked
    }
  }

  updateButtonState() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)
    
    if (checkedBoxes.length > 0) {
      this.editButtonTarget.disabled = false
      this.editButtonTarget.classList.remove('btn-outline-secondary', 'disabled')
      this.editButtonTarget.classList.add('btn-primary')
      this.editButtonTarget.style.opacity = '1'
    } else {
      this.editButtonTarget.disabled = true
      this.editButtonTarget.classList.remove('btn-primary')
      this.editButtonTarget.classList.add('btn-outline-secondary', 'disabled')
      this.editButtonTarget.style.opacity = '0.4'
    }
  }
}